<template>
    <div class="relative">
        <input
            :placeholder="placeholder"
            :type="type"
            :disabled="disabled"
            class="
                form-input
                border
                rounded-2xl
                w-full
                selected:border-blue-800
                focus:border-2
                focus:m-0
                disabled:opacity-50 disabled:border-gray-800 disabled:bg-gray-300 disabled:caret-transparent
            "
            :class="stateClasses"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
        />
        {{ stateName }}
        <Icon :name="stateName || iconName" class="absolute right-4 -translate-y-1/2 top-1/2 mr-1.5"/>
    </div>
</template>

<script>
import Textarea from "@/Components/Textarea.vue";
import Icon from "@/Components/UI/Icons/Icon.vue"

export default {
    components: { Textarea, Icon },
    props: {
        type: {
            type: String,
            default: "text",
        },
        state: {
            type: String,
            default: "default",
        },
        modelValue: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        iconName: {
            type: String,
            default: ''
        },
        disabled: {
            type: String,
        }
    },
    computed: {
        stateClasses() {
            if (this.state == "success") {
                return "border-success";
            }
            if (this.state == "error") {
                return "border-error";
            }
            return "border-gray-500";
        },

        stateName() {
            if (this.state == "success") {
                return "Sucesso";
            }
            if (this.state == "error") {
                return "Erro";
            }
        },
    },
    methods: {
        updateValue(value) {
            ///console.log(value);
            this.$emit("update-value", value);
        },
    },
};
</script>
